import script from "./WorksPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./WorksPicker.vue?vue&type=script&setup=true&lang=js"

import "./WorksPicker.vue?vue&type=style&index=0&id=0e1513ec&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1513ec"]])

export default __exports__